const userApi = {
  userInfo: '/api/potential-candidate-handbook/user-info',
  login: '/api/potential-candidate-handbook/login',
  logout: '/api/potential-candidate-handbook/logout',
  changePassword: '/api/potential-candidate-handbook/change-password',
};

export default userApi;
